define('plugin/contact-widget/ContactWidgetPlugin',['require','lib/plugin/PluginAbstract','plugin/contact-widget/controller/ContactWidgetController','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var ContactWidgetController = require('plugin/contact-widget/controller/ContactWidgetController');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        initialize: function () {
            var contactWidgetRouter = new AppRouter({
                appRoutes: {
                    'contact-widget': 'index'
                },

                menuItem: 'contact_widget',

                controller: new ContactWidgetController({
                    app: this.getOption('app')
                })
            });
        }

    });

});

